import { z } from 'zod';

export const PriorSubmissionOwnerUserSchema = z.object({
  fullName: z.string().nullable(),
});

export type PriorSubmissionOwnerUser = z.infer<
  typeof PriorSubmissionOwnerUserSchema
>;

export const PriorSubmissionSchema = z.object({
  focusArea: z.string().nullable(),
  industry: z.string().nullable(),
  name: z.string().nullable(),
  ownerUser: PriorSubmissionOwnerUserSchema,
  publishedAtDate: z.string().nullable(),
  summary: z.string().nullable(),
});

export type PriorSubmission = z.infer<typeof PriorSubmissionSchema>;

export const TalentSummaryBioSchema = z.object({
  candidateSummary: z.string().nullable(),
  candidateSummaryUpdatedAt: z.string().nullable(),
  name: z.string(),
});

export type TalentSummaryBio = z.infer<typeof TalentSummaryBioSchema>;

export const AiDraftSubmissionSchema = z.object({
  name: z.string(),
  summary: z.string(),
  receivedAt: z.string(),
});

export type AiDraftSubmission = z.infer<typeof AiDraftSubmissionSchema>;

export const PriorSubmissionsSchema = z.object({
  aiDraftSubmission: AiDraftSubmissionSchema.nullable(),
  priorSubmissions: z.array(PriorSubmissionSchema),
  talentSummaryBio: TalentSummaryBioSchema,
});

export type PriorSubmissions = z.infer<typeof PriorSubmissionsSchema>;
